import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { updateListValueTranslationReview } from '@global/api/taxonomy-translations'
import {
  ListValueTranslation,
  UpdateTranslationListValueReviewRequest,
} from '@taxonomy-translation/types'

export const useUpdateListValueTranslationReview = (
  translationUuid: string,
  options: UseMutationOptions<
    ListValueTranslation,
    Error,
    UpdateTranslationListValueReviewRequest
  > = {},
) =>
  useMutation({
    mutationFn: request => updateListValueTranslationReview(translationUuid, request),
    ...options,
  })
